import { createTheme } from '@mui/material/styles';
import { colors, fontFamily } from './tokens';

/* The one MUI theme for the whole app (provided once, in index.tsx). It replaces
   components/Wizard/theme.tsx (the former global theme, same values) and themes/index.ts
   (the auth pages' theme: MUI blue #1976D2 + orange, default heading sizes). */
const theme = createTheme({
    palette: {
        primary: {
            main : colors.primary,
            // Used as a pale background tint (selected cards, highlights), not a lighter accent
            light: colors.primaryTint,
        },
        secondary: {
            main: colors.textGrey,
        },
    },
    typography: {
        fontFamily,
        button: {
            textTransform: 'none',
        },
    },
    components: {
        MuiCardContent: {
            styleOverrides: {
                root: {
                    padding: '16px 16px',
                    '&:last-child': {
                        paddingBottom: '8px',
                    },
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    fontSize: '14px',
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    margin: 4,
                    color: 'red',
                },
            },
        },
        // The app's heading scale: compact, navy titles
        MuiTypography: {
            styleOverrides: {
                h2: { fontSize: '14px', color: colors.titleBlue, fontWeight: 'bolder', letterSpacing: '0.1px' },
                h3: { fontSize: '28px', color: colors.titleBlue, fontWeight: 'bolder', letterSpacing: '0.1px' },
                h4: { fontSize: '14px', color: colors.subtitleGrey, fontWeight: 'normal', letterSpacing: '0.1px' },
                h5: { fontSize: '18px', color: colors.titleBlue, fontWeight: 'bolder', letterSpacing: '0.1px' },
                h6: { fontSize: '16px', color: colors.textDark, fontWeight: 'bolder', letterSpacing: '0.1px' },
            },
        },
    },
});

/* Large display headings for the auth pages (login, signup, reset, unsubscribe), which used
   MUI's default sizes before the themes were merged. Apply with sx so they keep their size. */
export const displayHeading = {
    title   : { fontSize: '2.125rem', fontWeight: 500, color: '#000', my: '4px' },
    subtitle: { fontSize: '1.25rem', fontWeight: 500, color: '#000', my: '4px' },
};

export default theme;
